import { render, staticRenderFns } from "./RelatedVideos.vue?vue&type=template&id=6f418d0c&scoped=true&"
import script from "./RelatedVideos.vue?vue&type=script&lang=js&"
export * from "./RelatedVideos.vue?vue&type=script&lang=js&"
import style0 from "./RelatedVideos.vue?vue&type=style&index=0&id=6f418d0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f418d0c",
  null
  
)

export default component.exports